import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

const services = [
  ["Event Photography","/services/event-photography-new-orleans","Candid, editorial and flash-forward event coverage for celebrations, nightlife, private events and brand activations."],
  ["Foto Booth","/services/foto-booth-new-orleans","A hosted, guest-first booth experience with guided posing, digital delivery and optional instant keepsakes."],
  ["Real Estate Media","/services/real-estate-media-new-orleans","Listing photography and short-form property content for agents, owners, investors and property managers."],
  ["Food + Restaurant Photography","/services/restaurant-food-photography-new-orleans","Menu, cocktail, interior, staff and social-ready content for restaurants, bars and culinary brands."],
  ["Airbnb + Hospitality Media","/services/hospitality-airbnb-media-new-orleans","Property, amenity, detail and lifestyle visuals for short-term rentals, boutique stays and hospitality brands."],
  ["Business Content","/services/business-content-new-orleans","Brand photography, short-form video and recurring content production for websites, ads, social and Google Business."],
  ["Event Recap Video","/services/event-video-new-orleans","Cinematic event recaps and vertical social cutdowns that extend the life of the event."],
  ["Instant Photo Printing","/services/instant-photo-printing-new-orleans","On-site physical photo keepsakes produced during the event."],
  ["Open Bar for Photos","/services/open-bar-for-photos","Continuous roaming event photography paired with take-home prints for guests."],
];

export default function ServicesIndex(){
  const itemList={
    "@context":"https://schema.org",
    "@type":"ItemList",
    name:"Fotos on the Geaux services",
    itemListElement:services.map(([name,url],index)=>({
      "@type":"ListItem",position:index+1,name,url:`https://geauxfotos.com${url}`
    }))
  };
  return <div className="min-h-screen bg-[#080808] text-[#F5F0E8]">
    <Seo
      title="Photography, Video & Foto Booth Services New Orleans | Fotos on the Geaux"
      description="Explore Fotos on the Geaux services in New Orleans: event photography, Foto Booth, real estate media, food photography, hospitality content, business content, video and instant prints."
      path="/services"
      schema={[itemList]}
    />
    <main className="mx-auto max-w-6xl px-5 py-16 md:py-24">
      <Link to="/" className="text-sm text-white/50 hover:text-white">← Fotos on the Geaux</Link>
      <p className="mt-16 max-w-full font-accent text-[11px] tracking-[.24em] text-[#c8aa82] sm:text-xs sm:tracking-[.35em]">SERVICES · NEW ORLEANS</p>
      <h1 className="mt-5 max-w-5xl font-display text-6xl font-black leading-[.9] tracking-[-.04em] md:text-8xl">Visual media built to work after the shoot ends.</h1>
      <p className="mt-7 max-w-3xl text-lg leading-8 text-white/60">Photography, video, physical keepsakes and guest-facing experiences for events, businesses, restaurants, properties and hospitality brands across New Orleans and the Gulf South.</p>
      <section className="mt-14 divide-y divide-white/10 border-y border-white/10">
        {services.map(([name,url,copy],i)=><Link key={url} to={url} className="group grid min-w-0 gap-4 py-8 md:grid-cols-[50px_minmax(0,1fr)_minmax(0,1.2fr)_30px] md:items-center">
          <span className="font-accent text-[9px] text-white/25">{String(i+1).padStart(2,"0")}</span>
          <h2 className="font-display text-3xl font-bold">{name}</h2>
          <p className="text-sm leading-6 text-white/45">{copy}</p>
          <ArrowRight size={17} className="text-white/30 group-hover:text-white"/>
        </Link>)}
      </section>
      <div className="mt-12 flex flex-wrap gap-3">
        <Link to="/book" className="rounded-full bg-[#F5F0E8] px-6 py-3 font-accent text-[10px] tracking-[.2em] text-black">REQUEST A DATE</Link>
        <Link to="/insights" className="rounded-full border border-white/20 px-6 py-3 font-accent text-[10px] tracking-[.2em]">READ THE GUIDES</Link>
      </div>
    </main>
  </div>;
}
